var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 89,
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket-launch-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72.1765 42.0588C66.6211 47.5481 45 64.0294 45 64.0294M72.1765 42.0588C87 27.4118 87 17.6471 87 3C72.1765 3 62.2941 3 47.4706 17.6471M72.1765 42.0588L74.5245 53.6593C76.1447 61.6629 73.6094 69.9371 67.7679 75.709L61.9848 81.4233C59.6634 83.717 55.7658 83.1775 54.1718 80.3418L45 64.0294M45 64.0294L25.2353 44.5M47.4706 17.6471L25.2353 44.5M47.4706 17.6471L35.7301 15.3269C27.63 13.7262 19.2563 16.2314 13.4152 22.0029L7.63201 27.7173C5.31074 30.0109 5.85664 33.8623 8.72633 35.4374L25.2353 44.5M64.7647 24.973L59.8235 29.8553M3 86L19.7616 82.6878C24.3809 81.7748 27.7059 77.7674 27.7059 73.1125V71.3529C27.7059 65.9599 23.2814 61.5882 17.8235 61.5882H16.0428C11.3321 61.5882 7.27619 64.8736 6.35234 69.4381L3 86Z",
    stroke: "#A096FF",
    strokeWidth: 5.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.504398bd7b9cc6c74ccba15d11342d6a.svg";
export { ForwardRef as ReactComponent };